module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-04-ed70e8a3e5595a5d672b07645d991874.jpg";